import assetPath from '/app/packages/entity-pages/entity-pages-common/src/components/error-state/assets/error.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')